import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-wrapper footer-layout1 bg-dark">
      <div className="">
        <div className="container">
          <div className="newsletter-area">
            <div className="newsletter-top">
              <div className="row gy-4 align-items-center">
                

              </div>
            </div>
          </div>
          <div className="row justify-content-between">

            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">
                  <Link className="colorr" to="/Pune-to-Shirdi-Taxi"><i className="darkcolor"></i> Pune to Shirdi Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Bhimashankar-Taxi"><i className="darkcolor"></i> Pune to Bhimashankar Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Mumbai-Taxi"><i className="darkcolor"></i> Pune to Mumbai Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Lonavala-Taxi"><i className="darkcolor"></i> Pune to Lonavala Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Mahabaleshwar-Taxi"><i className="darkcolor"></i> Pune to Mahabaleshwar Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Aurangabad-Taxi"><i className="darkcolor"></i> Pune to Aurangabad Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Nashik-Trimbakeshwar-Taxi"><i className="darkcolor"></i> Pune to Nashik-Trimbakeshwar Taxi</Link>
                  <Link className="colorr" to="/Pune-Car-Rental-Services"><i className="darkcolor"></i> Pune Car Rental Services</Link>
                  <Link className="colorr" to="/Pune-to-Ashtavinayak-Taxi"><i className="darkcolor"></i> Pune to Ashtavinayak Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Goa-Taxi"><i className="darkcolor"></i> Pune to Goa Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Solapur-Taxi"><i className="darkcolor"></i> Pune to Solapur Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Hyderabad-Cab"><i className="darkcolor"></i> Pune to Hyderabad Cab</Link>
                  <Link className="colorr" to="/Pune-to-Kolhapur-Taxi"><i className="darkcolor"></i> Pune to Kolhapur Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Bangalore-Taxi"><i className="darkcolor"></i> Pune to Bangalore Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Indore-Taxi"><i className="darkcolor"></i> Pune to Indore Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Shirdi-Taxi"><i className="darkcolor"></i> Mumbai to Shirdi Taxi</Link>
                  <Link className="colorr" to="/Borivali-to-Pune-Taxi-Service"><i className="darkcolor"></i> Borivali to Pune Taxi Service</Link>
                  <Link className="colorr" to="/Vasai-to-Pune-Taxi-Service"><i className="darkcolor"></i> Vasai to Pune Taxi Service</Link>
                  <Link className="colorr" to="/Dombivali-to-Pune-Taxi-Services"><i className="darkcolor"></i> Dombivli to Pune Taxi Services</Link>
                  <Link className="colorr" to="/Dadar-to-Shirdi-Taxi-Service"><i className="darkcolor"></i> Dadar to Shirdi Taxi Service</Link>
                  <Link className="colorr" to="/Mumbai-to-Trimbakeshwar-Taxi"><i className="darkcolor"></i> Mumbai to Trimbakeshwar Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Bhimashankar-Taxi"><i className="darkcolor"></i> Mumbai to Bhimashankar Taxi</Link>
                  <Link className="colorr" to="/Mumbai-Central-to-Pune-Taxi"><i className="darkcolor"></i> Mumbai Central to Pune Taxi</Link>
                  <Link className="colorr" to="/Thane-to-Pune-Taxi-Service"><i className="darkcolor"></i> Thane to Pune Taxi Service</Link>
                  <Link className="colorr" to="/Mumbai-to-Nashik-Taxi"><i className="darkcolor"></i> Mumbai to Nashik Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Lonavala-Taxi"><i className="darkcolor"></i> Mumbai to Lonavala Taxi</Link>
                  <Link className="colorr" to="/Mumbai-Airport-to-Pune-Taxi"><i className="darkcolor"></i> Mumbai Airport to Pune Taxi</Link>
                  <Link className="colorr" to="/Kandivali-to-Pune-Taxi-Services"><i className="darkcolor"></i> Kandivali to Pune Taxi Services</Link>
                  <Link className="colorr" to="/NaviMumbai-to-Pune-Taxi-Services"><i className="darkcolor"></i> Navi Mumbai to Pune Taxi Services</Link>
                  <Link className="colorr" to="/Kalyan-to-Pune-Taxi-Service"><i className="darkcolor"></i> Kalyan to Pune Taxi Service</Link>
                  <Link className="colorr" to="/Mumbai-Central-to-Shirdi-Taxi"><i className="darkcolor"></i> Mumbai Central to Shirdi Taxi</Link>
                  <Link className="colorr" to="/Mumbai-Airport-to-Nashik-Taxi"><i className="darkcolor"></i> Mumbai Airport to Nashik Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Matheran-Taxi"><i className="darkcolor"></i> Mumbai to Matheran Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Mahabaleshwar-Taxi"><i className="darkcolor"></i> Mumbai to Mahabaleshwar Taxi</Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">


                  <Link className="colorr" to="/Mumbai-to-Ahmadnagar-Taxi"><i className="darkcolor"></i> Mumbai to Ahmadnagar Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Sambhajinagar-Taxi"><i className="darkcolor"></i> Pune to Sambhajinagar Taxi</Link>
                  <Link className="colorr" to="/Pune-Airport-to-Mumbai-Taxi"><i className="darkcolor"></i> Pune Airport to Mumbai Taxi</Link>
                  <Link className="colorr" to="/Mumbai-to-Solapur-Taxi"><i className="darkcolor"></i> Mumbai to Solapur Taxi</Link>
                  <Link className="colorr" to="/Pune-Cab-Service"><i className="darkcolor"></i> Pune Cab Service</Link>
                  <Link className="colorr" to="/Pune-Online-Cab-Booking"><i className="darkcolor"></i> Pune Online Cab Booking</Link>
                  <Link className="colorr" to="/Best-Cab-Service-in-Pune"><i className="darkcolor"></i> Best Cab Service in Pune</Link>
                  <Link className="colorr" to="/Pune-to-Mumbai-Cabs"><i className="darkcolor"></i> Pune to Mumbai Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Nasik-Cabs"><i className="darkcolor"></i> Pune to Nasik Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Mahabaleshwar-Cabs"><i className="darkcolor"></i> Pune to Mahabaleshwar Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Lonavala-Cabs"><i className="darkcolor"></i> Pune to Lonavala Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Shirdi-Cab"><i className="darkcolor"></i> Pune to Shirdi Cab</Link>
                  <Link className="colorr" to="/Pune-to-Lavasa-City-Cabs"><i className="darkcolor"></i> Pune to Lavasa City Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Bhimashankar-Cab"><i className="darkcolor"></i> Pune to Bhimashankar Cab</Link>
                  <Link className="colorr" to="/Pune-to-Indore-Cabs"><i className="darkcolor"></i> Pune to Indore Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Konkan-Darshan-Cabs"><i className="darkcolor"></i> Pune to Konkan Darshan Cabs</Link>
                  <Link className="colorr" to="/Pune-Outstation-Cabs"><i className="darkcolor"></i> Pune Outstation Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Panchgani-Cab-Fare"><i className="darkcolor"></i> Pune to Panchgani Cab Fare</Link>
                  <Link className="colorr" to="/Pune-to-Mumbai-International-Airport-Cab"><i className="darkcolor"></i> Pune to Mumbai International Airport Cab</Link>
                  <Link className="colorr" to="/Ashtavinayak-Darshan-Cab"><i className="darkcolor"></i> Ashtavinayak Darshan Cab</Link>
                  <Link className="colorr" to="/Pune-to-Nagpur-Cabs"><i className="darkcolor"></i> Pune to Nagpur Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Goa-Cabs"><i className="darkcolor"></i> Pune to Goa Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Ajanta-Ellora-Cabs"><i className="darkcolor"></i> Pune to Ajanta Ellora Cabs</Link> <Link className="colorr" to="/Pune-to-Satara-Cabs"><i className="darkcolor"></i> Pune to Satara Cabs</Link>
                  <Link className="colorr" to="/Cabs-Services-Near-Me"><i className="darkcolor"></i> Cabs Services Near Me</Link>
                  <Link className="colorr" to="/Corporate-Cab-Service-in-Pune"><i className="darkcolor"></i> Corporate Cab Service in Pune</Link>
                  <Link className="colorr" to="/Pune-to-Pandharpur-Taxi"><i className="darkcolor"></i> Pune to Pandharpur Taxi</Link>
                  <Link className="colorr" to="/Tempo-Traveller-On-Rent-in-Pune"><i className="darkcolor"></i> Tempo Traveller On Rent in Pune</Link>
                  <Link className="colorr" to="/Innova-Crysta-On-Rent-in-Pune"><i className="darkcolor"></i> Innova Crysta On Rent in Pune</Link>
                  <Link className="colorr" to="/Swift-Dzire-On-Rent-in-Pune"><i className="darkcolor"></i> Swift Dzire On Rent in Pune</Link>
                  <Link className="colorr" to="/Pune-to-Imagica-Taxi"><i className="darkcolor"></i> Pune to Imagica Taxi</Link>
                  <Link className="colorr" to="/Mini-Bus-On-Rent-in-Pune"><i className="darkcolor"></i> Mini Bus On Rent in Pune</Link>
                  <Link className="colorr" to="/Ertiga-On-Rent-in-Pune"><i className="darkcolor"></i> Ertiga On Rent in Pune</Link>
                  <Link className="colorr" to="/Kia-Carens-On-Rent-in-Pune"><i className="darkcolor"></i> Kia Carens On Rent in Pune</Link>
                </div>
              </div>
            </div>


            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">

                  <Link className="colorr" to="/Pune-to-Sambhaji-Nagar-Taxi-Fare"><i className="darkcolor"></i> Pune to Sambhaji Nagar Taxi Fare</Link>
                  <Link className="colorr" to="/Pune-to-Ganpatipule-Taxi"><i className="darkcolor"></i> Pune to Ganpatipule Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Harihareshwar-Taxi"><i className="darkcolor"></i> Pune to Harihareshwar Taxi</Link>
                  <Link className="colorr" to="/Pune-to-Alibag-Cabs"><i className="darkcolor"></i> Pune to Alibag Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Panvel-Cabs"><i className="darkcolor"></i> Pune to Panvel Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Hyderabad-Cabs"><i className="darkcolor"></i> Pune to Hyderabad Cabs</Link>
                  <Link className="colorr" to="/Pune-to-Bangalore-Taxi-Service"><i className="darkcolor"></i> Pune to Bangalore Taxi Service</Link>
                  <Link className="colorr" to="/One-Way-Cab-Pune"><i className="darkcolor"></i> One Way Cab Pune</Link>
                  <Link className="colorr" to="/Taxi-Service-in-Hadapsar"><i className="darkcolor"></i> Taxi Service in Hadapsar</Link>
                  <Link className="colorr" to="/Taxi-Service-in-Lohegaon"><i className="darkcolor"></i> Taxi Service in Lohegaon</Link>
                  <Link className="colorr" to="/Cab-Service-in-Viman-Nagar"><i className="darkcolor"></i> Cab Service in Viman Nagar</Link>
                  <Link className="colorr" to="/Cab-Service-in-Kharadi"><i className="darkcolor"></i> Cab Service in Kharadi</Link>
                  <Link className="colorr" to="/Taxi-Service-in-Hinjewadi-Pune"><i className="darkcolor"></i> Taxi Service in Hinjewadi Pune</Link>
                  <Link className="colorr" to="/Pune-to-Gujarat-Cab-Service"><i className="darkcolor"></i> Pune to Gujarat Cab Service</Link>
                  <Link className="colorr" to="/Pune-to-Thane-Cab"><i className="darkcolor"></i> Pune to Thane Cab</Link>
                  <Link className="colorr" to="/Outstation-Taxi-Service-Pune"><i className="darkcolor"></i> Outstation Taxi Service Pune</Link>



                  <Link className="colorr" to="/Pune-To-Nashik-Trimbakeshwar-Cabs"><i className="darkcolor"></i> Pune To Nashik Trimbakeshwar Cabs</Link>
                  <Link className="colorr" to="/Pune-To-Pandharpur-Cabs"><i className="darkcolor"></i> Pune To Pandharpur Cabs</Link>
                  <Link className="colorr" to="/Pune-To-Tuljapur-Cabs"><i className="darkcolor"></i> Pune To Tuljapur Cabs</Link>
                  <Link className="colorr" to="/Pune-To-Kolhapur-Cab"><i className="darkcolor"></i> Pune To Kolhapur Cab</Link>
                  <Link className="colorr" to="/Pune-To-Ashtavinayak-Tour-Cab-Package"><i className="darkcolor"></i> Pune To Ashtavinayak Tour Cab Package</Link>
                  <Link className="colorr" to="/Pune-To-3-Jyotirlinga-Tour-Package"><i className="darkcolor"></i> Pune To 3 Jyotirlinga Tour Package</Link>
                  <Link className="colorr" to="/Pune-To-Lonavala-Khandala-Cabs"><i className="darkcolor"></i> Pune To Lonavala Khandala Cabs</Link>
                  <Link className="colorr" to="/Pune-To-Ganpatipule-Cab-Booking"><i className="darkcolor"></i> Pune to Ganpatipule Cab Booking</Link>
                  <Link className="colorr" to="/Pune-To-Akkalkot-Cab"><i className="darkcolor"></i> Pune to Akkalkot Cab</Link>
                  <Link className="colorr" to="/Pune-To-Mumbai-Airport-Cab"><i className="darkcolor"></i> Pune to Mumbai Airport Cab</Link>
                  <Link className="colorr" to="/Mumbai-Airport-To-Pune-Cab-Service"><i className="darkcolor"></i> Mumbai Airport to Pune Cab Service</Link>
                  <Link className="colorr" to="/Affordable-Cab-Service-in-Pune"><i className="darkcolor"></i> Affordable Cab Service in Pune</Link>
                  <Link className="colorr" to="/Pune-To-Outstation-Taxi-Service"><i className="darkcolor"></i> Pune To Outstation Taxi Service</Link>
                  <Link className="colorr" to="/Online-Cab-Service-Pune"><i className="darkcolor"></i> Online Cab Service Pune</Link>
                  <Link className="colorr" to="/Cheapest-Cab-Service-in-Pune"><i className="darkcolor"></i> Cheapest Cab Service in Pune</Link>

                </div>
              </div>
            </div>

            <div className="col-md-3 col-xl-3">
              {/* <div className=""> */}
              <h3 className="">Address</h3>
              {/* <div className=""> */}
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/phone.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a href="tel:+919371304510" className="info-box_link text-white">
                      +91 9371304510
                    </a>
                  </p>
                  <p>
                    <a href="tel:+918379975860" className="info-box_link text-white">
                      +91 8379975860
                    </a>
                  </p>
                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/envelope.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a
                      href="mailto:booking@moryacab.com"
                      className="info-box_link text-white"
                    >
                      booking@moryacab.com
                    </a>
                  </p>

                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/location-dot.svg" alt="img" />
                </div>
                <div className="details">
                  <p className='text-white'>
                    <h6>Morya Cab</h6>
                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105</p>
                </div>
              </div>

              {/* <div className="container-fluid"> */}
              <div className="">


      
                <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d382387.639051183!2d73.900641!3d18.673912!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c628ae2ec5f9%3A0x8a544100d62851fe!2sMWF2%2BH76%2C%20Alandi%2C%20Pune%2C%20Maharashtra%20412105%2C%20India!5e1!3m2!1sen!2sus!4v1739862714211!5m2!1sen!2sus"
  width="auto"
  height="auto"
  allowFullScreen=""
  loading="lazy"
  title="Google Map showing location in Alandi, Pune"
/>

              </div>
              {/* </div> */}

            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      <div className="copyright-wrap" data-bg-src="/img/bg/copyright_bg_1.jpg">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6">

              <p className="copyright-text">
                All Rights Reserved &copy;  <span className="darkcolorr">Morya Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolorr">&nbsp;Dexter Intelligence</span>
                </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolorr">&nbsp;Urva Hosting</span>
                </a>
              </p>
            </div>
            <div className="col-md-6 text-end d-none d-md-block">
              <div className="footer-card">
                <span className="title">We Accept</span>
                <img src="/img/shape/cards.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
